import * as api from "../api";

export const signIn = (formData, navigate) => async (dispatch) => {
  try {
    await api.signIn(formData);

    navigate("/admin", {
      state: {
        message: `Welcome back admin ${formData.admin} `,
      },
    });
  } catch (error) {
    return error.response.data;
  }
};
export const extendSession = async (sessionTime) => {
  try {
    await api.extendSession(sessionTime);
  } catch (error) {
    return error.response;
  }
};
